import { callAPi } from './http-common';

const add = (data) => {
  return callAPi.post('/createCustomDesignSeo', data);
};
const get = () => {
  return callAPi.get('/getAllCustomDesignSeos');
};
const getbyid = (id) => {
  return callAPi.get(`/getCustomDesignSeoById/${id}`);
};
const update = (id, data) => {
  return callAPi.patch(`/updateCustomDesignSeoById/${id}`, data);
};
const deletes = (id) => {
  return callAPi.patch(`/deleteCustomDesignSeoById/${id}`);
};
const CustomProductSEOService = {
  add,
  get,
  update,
  deletes,
  getbyid,
};

export default CustomProductSEOService;
